{
    "Profile_TestMode.title": "Mode test",
    "Profile_TestMode.description": "Remplacer les dates pour les tests",
    "Profile_TestMode.descriptionDisabled": "Le mode test est désactivé globalement",
    "Profile_TestMode.isPolicyInTestModeLabel": "Activer le mode test pour cette police",
    "Profile_TestMode.realGoFirmDate": "GoFirmDate actuel",
    "Profile_TestMode.goFirmDateTestLabel": "GoFirmDate Test"
}
